import { gtagLineEvent } from "@/utils/gtag";

const LINE_URL = "https://lin.ee/8C3Fu5jX";
const GTAG_EVENT = "YAMEBI_1_LINE友達追加_モニター実績セクション";

export default function StatsSection() {
  return (
    <section className="bg-[#1a1a1a] py-20 px-6">
      <div className="max-w-3xl mx-auto text-center">
        <p className="text-sm text-[#66E066] font-bold tracking-widest uppercase mb-4">MONITOR TEST</p>
        <h2 className="text-white text-2xl md:text-3xl font-black mb-8">
          YAMEBIが実施した<br className="sm:hidden" />モニター試験では、<br />
          参加者の<span className="text-[#66E066] text-4xl md:text-6xl font-black">90%</span>が<br className="md:hidden" />
          1ヶ月後も設定した<br className="sm:hidden" />ルールを継続しています。
        </h2>

        {/* 統計ビジュアル */}
        <div className="flex justify-center gap-3 mb-10 flex-wrap">
          {Array.from({ length: 30 }).map((_, i) => (
            <div
              key={i}
              className={`w-10 h-10 flex items-center justify-center rounded-full ${
                i < 27 ? "bg-[#00B900]" : "bg-white/20"
              }`}
            >
              <i className={`ri-user-fill text-lg ${i < 27 ? "text-white" : "text-white/40"}`}></i>
            </div>
          ))}
        </div>
        <p className="text-white/60 text-sm mb-10">
          30名中 <span className="text-[#66E066] font-bold text-lg">27名</span> が1ヶ月間ルールを継続
        </p>

        {/* 試験概要 */}
        <div className="bg-white/5 border border-white/10 rounded-2xl p-6 text-left mb-10">
          <h3 className="text-white font-bold text-base mb-3">試験概要</h3>
          <p className="text-white/70 text-sm leading-relaxed">
            本試験は2026年1月に実施しました。お菓子・ジャンクフード・甘いものなどを週4〜7回以上購入または摂取する習慣がある20〜50代の男女30名を対象に、通常のYAMEBIサービス利用と同じ方法で1ヶ月間のモニター試験を行いました。継続状況は、システム判定と参加者自己申告の二重確認により判定しています。
          </p>
          <p className="text-white/40 text-xs mt-3">
            ※2026年1月の1ヶ月モニター試験にて、30名中27名が特定のルールを継続。当社調べ。結果には個人差があり、同様の結果を保証するものではありません。
          </p>
        </div>

        <a
          href={LINE_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => { e.preventDefault(); gtagLineEvent(LINE_URL, GTAG_EVENT); }}
          className="whitespace-nowrap inline-flex items-center gap-2 bg-[#00B900] hover:bg-[#009900] text-white font-bold text-base py-3 px-8 rounded-full transition-all cursor-pointer shadow-[0_8px_25px_rgba(0,185,0,0.5)] hover:shadow-[0_12px_35px_rgba(0,185,0,0.65)] hover:scale-105"
        >
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-line-fill text-lg"></i>
          </span>
          公式LINEを友だち追加する
        </a>
        <p className="text-white/50 text-xs mt-2">まずはLINEで禁食の仕組みを確認</p>
      </div>
    </section>
  );
}
